import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_NEW_SEARCH_PAGE_ACCESS_EXPERIMENT = defineFcm('new_search_page_access_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			optional: true,
			shape: {
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault({
		enabled: false,
	})
	.toConfig();
